import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  padding: {
    default: 'pt-0'
  }
} satisfies RecursivePartial<PagesConfig['cms']>
